import '../assets/css/Prijava.css'
import { Alert, Button, Form, Input, Modal } from "antd"
import { useCallback, useContext, useState } from 'react'
import UserContext from '../context/UserContext'
import { useModalContext } from '../context/ModalContext'
import noRefreshClient, { setMessageBasedOnErrorMessage } from '../services/api/NoRefreshClient'


function Prijava() {
    const [showWarning, setShowWarning] = useState(false)
    const [error, setError] = useState(String)
    const { setUserContext } = useContext(UserContext)
    const { displayCustomNameModal, sessionExpired, displayGenericErrorModal, resetModalContext } = useModalContext()

    const onClose = useCallback(() => {
        resetModalContext()
    }, [resetModalContext])

    const openRegistracijaModal = useCallback(() => {
        displayCustomNameModal('registracija')
    }, [displayCustomNameModal])

    const openEmailInputModal = useCallback(() => {
        displayCustomNameModal('emailInput')
    }, [displayCustomNameModal])

    const submitForm = useCallback(async (values) => {
        var formData = new FormData();
        formData.append("username", values.username)
        formData.append("password", values.password)
        return noRefreshClient.post('login', formData)
        .then(data => {
            const token = data.data.token
            setUserContext(token)
            onClose()
        })
        .catch(error => {
            setMessageBasedOnErrorMessage(error)
            setError(error.message)
            setShowWarning(true)
        })
    }, [setUserContext, onClose, setError, setShowWarning, displayGenericErrorModal])

    return (
        <Modal 
            open={true}
            footer={null}
            onCancel={onClose}
            centered
        >
            <div className="Prijava">
                <div className="PrijavaForm">
                    <Form onFinish={submitForm} className="Form">
                        <h2 className="FormTitle">PRIJAVA</h2>

                        {sessionExpired && <p>Vaša sesija je istekla. Prijavite se ponovo.</p>}

                        <Form.Item name="username"                            
                            rules={[
                                {
                                    required: true,
                                    message: 'Korisničko ime je obavezno polje',
                                },
                            ]}>
                            <Input placeholder="Korisničko ime" className="inputField"/>
                        </Form.Item>

                        <Form.Item name="password"                            
                            rules={[
                                {
                                    required: true,
                                    message: 'Lozinka je obavezno polje',
                                },
                            ]}>
                            <Input.Password
                                type="password"
                                placeholder="Lozinka"
                                className="inputField"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button onClick={openEmailInputModal} className="login-form-button custom-button secondaryButton button-as-link">
                                Zaboravili ste lozinku?
                            </Button>
                        </Form.Item>

                        {showWarning ?
                            <Alert
                                message="Greška"
                                description={error}
                                type="error"
                                style={{ marginBottom: '20px' }}
                                showIcon
                            /> : null
                        }

                        <Form.Item>
                            <Button htmlType="submit" className="login-form-button custom-button primaryButton">
                                PRIJAVA
                            </Button>
                        </Form.Item>

                        <Form.Item>
                            <Button className="login-form-button custom-button secondaryButton" onClick={openRegistracijaModal}>
                                Kreiraj račun
                            </Button>
                        </Form.Item>

                    </Form>
                </div>
            </div>
        </Modal>
    )
}

export default Prijava